import { CommonModule } from '@angular/common';
import { DndModule, DragDropConfig, DragDropService, DragDropSortableService } from 'ng2-dnd';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SelectColumnComponent } from './select-column.component';
import { PipeModule } from 'clink-ui-x/pipe';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzGridModule } from 'ng-zorro-antd/grid';

@NgModule({
    declarations: [SelectColumnComponent],
    imports: [CommonModule, DndModule, FormsModule, NzCheckboxModule, NzGridModule, PipeModule],
    exports: [SelectColumnComponent],
    providers: [DragDropService, DragDropConfig, DragDropSortableService],
})
export class SelectColumnModule {}
